// Upload CV to the SAME server where this form is hosted.
// Using window.location.origin ensures each company's deployment
// stores CVs on their own server — no cross-server privacy leaks.

export async function uploadCV(file, meta = {}) {
  if (!file) throw new Error('UPLOAD_ERROR: No file provided');

  // ── Client-side validation ────────────────
  const allowedTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ];
  const allowedExts = ['pdf', 'doc', 'docx'];
  const ext         = file.name.split('.').pop().toLowerCase();
  const maxSize     = 2 * 1024 * 1024; // 2MB

  if (!allowedExts.includes(ext)) {
    throw new Error('UPLOAD_ERROR: Only PDF, DOC, DOCX files are allowed');
  }
  if (!allowedTypes.includes(file.type)) {
    throw new Error('UPLOAD_ERROR: Invalid file type');
  }
  if (file.size > maxSize) {
    throw new Error('UPLOAD_ERROR: File size must be under 2MB');
  }

  // ── Build FormData ────────────────────────
  const formData = new FormData();
  formData.append('cv', file);
  if (meta.branch_name)  formData.append('branch_name',  meta.branch_name);
  if (meta.company_name) formData.append('company_name', meta.company_name);
  formData.append('upload_date', new Date().toISOString());

  // ── Upload to current domain only ─────────
  // CV goes to whichever server this form is deployed on.
  // No external server — no privacy cross-contamination.
  const uploadUrl = `${window.location.origin}/upload-cv.php`;

  let res, data;
  try {
    res = await fetch(uploadUrl, { method: 'POST', body: formData });
  } catch (err) {
    throw new Error(`UPLOAD_FAILED: Cannot reach upload server — ${err.message}`);
  }

  try {
    data = await res.json();
  } catch {
    data = {};
  }

  if (!res.ok || !data?.url) {
    throw new Error(`UPLOAD_FAILED: ${data?.error || res.status}`);
  }

  return {
    url:           data.url,
    file_name:     data.file_name,
    original_name: data.original_name,
    size_kb:       data.size_kb,
  };
}
